import React from 'react';

import styled, { createGlobalStyle } from 'styled-components';

export const SPEED_TO_LEAD_FOLLOW_UP_TOOLTIP_CLASS_NAME = 'speed-to-lead-follow-up-tooltip';

const TooltipStyles = createGlobalStyle`
  .${SPEED_TO_LEAD_FOLLOW_UP_TOOLTIP_CLASS_NAME} .ant-tooltip-inner {
    width: max-content;
    min-width: 113px;
    max-width: 240px;
    min-height: 63px;
    padding: 6px 15px 5px 11px;
    color: var(--white);
    border: 1px solid var(--white);
    border-radius: 10px;
    background: linear-gradient(
      to left,
      var(--community-marker-purple-light) 99%,
      var(--community-marker-purple-dark)
    );
    box-shadow: 0 10px 30px var(--box-shadow-gray-dark);
  }
`;

const Content = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  gap: 1px;
  font-size: 10px;
`;

const Community = styled.div`
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const Touches = styled.div`
  margin-top: 3px;
  font-size: 12px;

  span {
    font-size: 16px;
  }
`;

const SequenceChannel = styled.div`
  margin-top: 3px;
  font-family: var(--font-regular);
  font-size: 16px;
`;

type Props = {
  channelLabel: string;
  channelTouches?: number;
  communityName: string;
  day?: number;
  totalTouches?: number;
};

const SpeedToLeadFollowUpTooltip = ({ channelLabel, channelTouches, communityName, day, totalTouches }: Props) => (
  <>
    <TooltipStyles />
    <Content>
      <Community>{communityName}</Community>
      {day == null ? (
        <>
          <div>{channelLabel}</div>
          <Touches>
            <span>{channelTouches}</span>/{totalTouches} touches
          </Touches>
        </>
      ) : (
        <>
          <div>Day {day}</div>
          <SequenceChannel>{channelLabel}</SequenceChannel>
        </>
      )}
    </Content>
  </>
);

export default SpeedToLeadFollowUpTooltip;
